import React from 'react';
import styled from 'styled-components';
import { Div } from 'components/Elements/Div/Div';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Divider from '@mui/material/Divider';
import CustomIcon from '../Icon/CustomIcon';
import iconCopy from 'assets/icons/iconCopy.svg';
import iconDelete from 'assets/icons/iconDelete.svg';
import SettingsBackupRestoreIcon from '@mui/icons-material/SettingsBackupRestore';

const ReorderableContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.offWhite};
  border-radius: 0.75rem;
  width: 100%;
`;

type Props = {
  children: React.ReactNode;
  onDelete?: () => void;
  onDrag?: () => void;
  onUp?: () => void;
  onDown?: () => void;
  onCopy?: () => void;
  title?: string;
  removed?: boolean;
};

const ReorderableComponent: React.FC<Props> = ({
  children,
  title,
  onDelete,
  onDrag,
  onUp,
  onDown,
  onCopy,
  removed,
}) => {
  return (
    <ReorderableContainer>
      <Div display='flex' width='100%' justifyContent='space-between' padding='1rem 2rem 0'>
        <Div display='flex' alignItems='center'>
          {onDrag && <CustomIcon icon={<DragIndicatorIcon />} onClick={onDrag} />}
          {onUp && <CustomIcon icon={<KeyboardArrowUpIcon />} onClick={onUp} />}
          {onDown && <CustomIcon icon={<KeyboardArrowDownIcon />} onClick={onDown} />}
          {(onUp ?? onDown ?? onDrag) && (
            <Divider flexItem orientation='vertical' sx={{ margin: '0 1rem' }} />
          )}
          {title}
        </Div>
        <Div>
          {onCopy && (
            <CustomIcon
              margin={'0 0.5rem 0 0'}
              imgIcon={iconCopy}
              onClick={onCopy}
              altText='Copy Icon'
            />
          )}
          {onDelete && (
            <CustomIcon
              imgIcon={!removed ? iconDelete : undefined}
              icon={removed && <SettingsBackupRestoreIcon />}
              altText='Delete Icon'
              onClick={onDelete}
            />
          )}
        </Div>
      </Div>
      {children}
    </ReorderableContainer>
  );
};

export default ReorderableComponent;
